
<template>
    <div class="login" >
        <v-container>
          <v-row class="text-center" align="center" align-self="center">

            <v-col md="6" offset-md="3" >
              <v-card class="overflow-hidden mt-12 mx-auto" max-width="600">
                  <v-toolbar flat color="secondary">

                    <v-toolbar-title class="font-weight-light white--text" >
                      {{$t('administration.user.connexion')}}
                    </v-toolbar-title>
                  </v-toolbar>
                  <LoginForm ref="LoginForm" :values="item" :errors="violations" :submitlogin="connexion" />
                  <v-divider></v-divider>
                  <v-card-actions class="pa-6">
                      <router-link class="text-decoration-underline" :to="{ name: 'ForgotPassword' }">{{$t('administration.user.forgotyourpassword')}}</router-link>
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="connexion"
                        color="primary"
                      >
                        {{$t('administration.user.connexionBtn')}}
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
       </v-container>
       <Loading :visible="isLoading" />
    </div>
</template>
<script>
  import { createHelpers } from 'vuex-map-fields';
  import { mapActions, mapState } from 'vuex';
  import LoginForm from '../../components/login/Login.vue';
  import Loading from '../../components/Loading';
  import NotificationMixin from '../../mixins/NotificationMixin';

  const servicePrefix = 'User';

  const { mapFields } = createHelpers({
    getterType: 'user/getField',
    mutationType: 'user/updateField'
  });

  export default {
    name: 'Login',
    servicePrefix,
    mixins: [NotificationMixin],
    components: {
      Loading,
      LoginForm
    },
    computed: {
      ...mapFields(['error', 'isLoading', 'created', 'violations']),
      ...mapState('user', {
        actioned: 'actioned',
        action: 'action',
        error: 'error',
        isLoading: 'isLoading',
      })
    },
    data() {
      return {
        item: {}
      };
    },
    created: function(){
      if (this.$root.isConnected) {
        this.$router.push({ name: `Home` });
      }
    },
    methods: {
      connexion() {

        const LoginForm = this.$refs.LoginForm;
        LoginForm.$v.$touch();
        if (!LoginForm.$v.$invalid) {
          this.userPushAction({action: 'login',values: {'login' :LoginForm.$v.item.$model.login, 'password' : LoginForm.$v.item.$model.password}});

        } else {
          console.log('error');
        }
      },
      ...mapActions({
        userPushAction: 'user/action'
      }),

      connected(item) {

        if (item.regen_password &&  item.regen_password == true) {
          console.log("regen_password");
          this.$root.passwordTurnover = true;
          this.$router.push({ name: `PasswordTurnover` });
        } else {
          this.$root.isConnected = true;
          console.log("connected");
          
          if(this.$root.originalUrlConnected) {
            this.$router.push({ name: this.$root.originalUrlConnected.name , params: this.$root.originalUrlConnected.params});
            this.$root.originalUrlConnected = null;
          }
          //this.$router.push({ name: `Home` });
          window.location.reload(false);
        }

        this.showMessage(this.$t('administration.user.connected'));
      },

    },
    watch: {
      actioned(actioned) {
        if (!actioned) {
          return;
        }
        if (this.action == 'login') {
          this.connected(actioned);
        }
      },

      error(message) {
        message && this.showError(message);
      }
    }
  }
</script>
